import { render, staticRenderFns } from "./DepartmentBasicInfo.vue?vue&type=template&id=5d3e6721&scoped=true"
import script from "./DepartmentBasicInfo.vue?vue&type=script&lang=js"
export * from "./DepartmentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./DepartmentBasicInfo.vue?vue&type=style&index=0&id=5d3e6721&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e6721",
  null
  
)

export default component.exports